import { render, staticRenderFns } from "./dataStatisticsChart.vue?vue&type=template&id=225d4f88"
import script from "./dataStatisticsChart.vue?vue&type=script&lang=js"
export * from "./dataStatisticsChart.vue?vue&type=script&lang=js"
import style0 from "./dataStatisticsChart.vue?vue&type=style&index=0&id=225d4f88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports